import { useEffect, useRef } from 'react';

import { useUserContext } from 'hooks/useUserContext';

import { trackValuePropsViewed } from 'utils/segment/trackingEvents';

export const useValuePropsSegmentEvents = (
  entry: {
    isIntersecting?: any;
    intersectionRatio?: any;
  },
  pageLocation: string
) => {
  const [userData] = useUserContext();
  const { publicId } = userData;

  const seenValuePropOnce = useRef<{ half: boolean; full: boolean }>({
    half: false,
    full: false,
  });

  useEffect(() => {
    const { isIntersecting, intersectionRatio } = entry;
    if (isIntersecting) {
      const { half, full } = seenValuePropOnce.current || {};
      if (intersectionRatio >= 0.5 && intersectionRatio <= 0.59 && !half) {
        seenValuePropOnce.current.half = true;
        trackValuePropsViewed(pageLocation, publicId, 'Half');
      }
      if (intersectionRatio >= 0.9 && intersectionRatio <= 1.0 && !full) {
        seenValuePropOnce.current.full = true;
        trackValuePropsViewed(pageLocation, publicId, 'Full');
      }
    }
  }, [entry, publicId, pageLocation]);
};
